export const TITLE_OPTIONS = [
'mr',
'ms',
'mrs',
'miss',
'mx',
'dr',
'prof',
'prefer_not_to_say',
] as const;

export type TitleOption = (typeof TITLE_OPTIONS)[number];